import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import React, { useState, useEffect } from "react";
import InputAdornment from '@mui/material/InputAdornment';
import { InputBase } from '@mui/material';
import { GET_ADDRESS_BY_PINCODE, UPLOAD_DCUMENT, authKey, ResourceUpdateMember } from '../../../../common/URLs';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import apiClient from '../../../../axios';
import { ADD_POPOVER, API_DATE_FORMAT, BASIC_DATE_FORMAT, CANCEL_POPOVER, DRIVING_LICENSE, EMPTY_FIELD_ERROR, GENDER, LOI_ABRPL_AGREEMENT, MOBILE_NO_ERROR, NUMBER_OF_MONTH, PINCODE_NO_ERROR, UPDATE_POPOVER, UPLOAD_FILE_TEXT } from '../../../../common/constants';
import moment from 'moment';
import { mobileNumberValidation, nameValidation, pincodeValidation, VALIDATION } from '../../../../common/commonValidations';
import { FileUploadMUI } from "../../../../common/fileUpload/fileUploadMUI";
import { PROD } from '../../../../common/constants';
import { Container, Card, Button, CardContent, RadioGroup, Radio, FormGroup, FormLabel, FormControlLabel, Checkbox, Stack, Box, Typography, Grid, FormHelperText, FormControl, InputLabel, Select, MenuItem, TextField } from '@mui/material';
import { v4 as uuidv4 } from 'uuid';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { subYears } from 'date-fns';
import { useTranslation } from 'react-i18next';
import { handleNumberFieldFocus } from '../../../../common/commonFunction';

export const ManpowerDetailsTransporter = (props) => {
    const { t } = useTranslation();
    const [transporterDetails, setTransporterDetails] = useState();
    const [id, setId] = useState('');
    const [fullName, setFullName] = useState();
    const [dob, setDob] = useState(moment(subYears(new Date(), 18)).format(API_DATE_FORMAT));
    const [gender, setGender] = useState('Male');
    const [mobileNo, setMobileNo] = useState();
    const [mobileNoErr, setMobileNoErr] = useState();

    const [pincode, setPincode] = useState();
    const [pincodeErr, setPincodeErr] = useState();

    const [address, setAddress] = useState();
    const [licenseNo, setLicense] = useState();
    const [drivingExp, setDrivingExp] = useState();

    const [drivingExpInYrs, setDrivingExpInYrs] = useState(0);
    const [drivingExpInMonths, setDrivingExpInMonths] = useState(0);
    const [licenceIssueDate, setLicenceIssueDate] = useState(moment(new Date()).format(API_DATE_FORMAT));
    const [licenceValidityEnddate, setLicenceValidityEnddate] = useState(moment(new Date()).format(API_DATE_FORMAT));

    const [agreementStartDate, setAgreementStartDate] = useState();
    const [agreementStartDisplay, setAgreementStartDisplay] = useState();

    const [agreementEndDate, setAgreementEndDate] = useState();
    const [agreementEndDisplay, setAgreementEndDisplay] = useState();
    const [documentArray, setDocumentArray] = useState([]);
    const [errorMessage, setErrorMessage] = useState({
        fullNameError: '',
        driverDobError: '',
        mobileNoError: '',
        addressError: '',
        drivingLicenseError: '',
        pincodeError: '',
        documentError: '',
    });

    let checkUserDetails = localStorage.getItem('role');
    useEffect(() => {
        if (props.data) {
            setTransporterDetails(props.data)
            setUseStateData();
        }

    }, [transporterDetails])
    useEffect(() => {
        if (drivingExpInMonths || drivingExpInYrs) {
            let concatenateValue = parseFloat(drivingExpInYrs + '.' + drivingExpInMonths)
            setDrivingExp(concatenateValue);
        }
    }, [drivingExpInMonths, drivingExpInYrs]);

    const setUseStateData = () => {
        if (transporterDetails) {
            let docType = transporterDetails?.documents
            let agreementStartDate = transporterDetails.agreementStartDate
            let agreementEndDate = transporterDetails.agreementEndDate
            let totalExp = transporterDetails?.yearsOfExp ? transporterDetails?.yearsOfExp : 0

            setId(transporterDetails?.id ? transporterDetails?.id : null)
            setFullName(transporterDetails?.driverName ? transporterDetails?.driverName : '')
            setDob(transporterDetails?.driverDob ? transporterDetails?.driverDob : moment(subYears(new Date(), 18)).format(API_DATE_FORMAT))
            setGender(transporterDetails?.driverGender ? transporterDetails?.driverGender : 'Male')
            setMobileNo(transporterDetails?.driverContactNo ? transporterDetails?.driverContactNo : '')
            setAddress(transporterDetails?.driverAddress ? transporterDetails?.driverAddress : '')
            setDrivingExp(transporterDetails?.yearsOfExp ? transporterDetails?.yearsOfExp : 0)
            setLicense(transporterDetails?.driverLicenseId ? transporterDetails?.driverLicenseId : '')
            setPincode(transporterDetails?.driverPincode ? transporterDetails?.driverPincode : '')
            setLicenceIssueDate(transporterDetails?.licenceIssueDate ? transporterDetails?.licenceIssueDate : moment(new Date()).format(API_DATE_FORMAT))
            setLicenceValidityEnddate(transporterDetails?.licenceValidityEnddate ? transporterDetails?.licenceValidityEnddate : moment(new Date()).format(API_DATE_FORMAT))
            setAgreementStartDate(agreementStartDate ? agreementStartDate : moment(new Date()).format(API_DATE_FORMAT))
            setAgreementStartDisplay(agreementStartDate ? moment(agreementStartDate).format(BASIC_DATE_FORMAT) : moment(new Date).format(BASIC_DATE_FORMAT))
            setAgreementEndDate(agreementEndDate ? agreementEndDate : moment(new Date()).format(API_DATE_FORMAT))
            setAgreementEndDisplay(agreementEndDate ? moment(agreementEndDate).format(BASIC_DATE_FORMAT) : moment(new Date).format(BASIC_DATE_FORMAT))
            setDrivingExpInYrs(totalExp.toString().split(".")[0] ? parseInt(totalExp.toString().split(".")[0]) : 0)
            setDrivingExpInMonths(totalExp.toString().split(".")[1] ? parseInt(totalExp.toString().split(".")[1]) : 0)
            setDocumentArray(transporterDetails?.documents);
        }

    }

    const onAgreementStartDateChange = (e) => {
        let selectedDate = e.target.value
        let formattedDate = moment(selectedDate).format(API_DATE_FORMAT)
        setAgreementStartDisplay(selectedDate)
        setAgreementStartDate(formattedDate)

    }
    const onAgreementEndDateChange = (e) => {
        let selectedDate = e.target.value
        let formattedDate = moment(selectedDate).format(API_DATE_FORMAT)
        setAgreementEndDisplay(selectedDate)
        setAgreementEndDate(formattedDate)

    }

    const onDriverGenderChange = (e) => {
        e.preventDefault();
        setGender(e.target.value)
    }
    const handleMobileNo = (e) => {
        let regdrivercheck = props.driverDataReload ? props.driverDataReload : props?.regStakeholderMaster?.transporterDrivers;
        e.preventDefault();
        setMobileNo(mobileNumberValidation(e.target.value));
        if ((e.target.value.toString()).length >= 10) {
            if (props.actionType === "edit" && regdrivercheck?.filter(item => (item.driverContactNo == (e.target.value))).length == 0) {

                setErrorMessage({ ...errorMessage, mobileNoError: '' })
            }
            else if (props.actionType === "add")
                setErrorMessage({ ...errorMessage, mobileNoError: '' })
            else setErrorMessage({ ...errorMessage, mobileNoError: "Contact No already exists." })

        }
        else {
            setErrorMessage({ ...errorMessage, mobileNoError: "Please enter valid Mobile No." })
        }
    }
    const handlePincodeChange = (e) => {
        e.preventDefault();
        setPincode(pincodeValidation(e.target.value))
        if ((e.target.value).length !== 6) {
            setErrorMessage({ ...errorMessage, pincodeError: "Please enter valid Pincode" })
        } else {
            setErrorMessage({ ...errorMessage, pincodeError: '' })
        }
    }
    const handleDateChange = (e, name) => {
        if (name === "licenceIssueDate") {
            setLicenceIssueDate(e.format(API_DATE_FORMAT))
        }
        if (name === "licenceValidityEnddate") {
            setLicenceValidityEnddate(e.format(API_DATE_FORMAT))
        }
    }
    const handleFullNameChange = (e) => {
        e.preventDefault();
        setFullName(e.target.value.slice(0, 50))
        if (e.target.value.length > 0) {
            setFullName(VALIDATION.fullNameValidation(e.target.value))
            setErrorMessage({ ...errorMessage, fullNameError: '' })
        } else setErrorMessage({ ...errorMessage, fullNameError: "Please enter Driver Name" })
    }
    const handleDrivingExp = (e) => {
        e.preventDefault();
        setDrivingExp(e.target.value)
    }
    const handleDriverDobChange = (e) => {
        setDob(e.format(API_DATE_FORMAT))
        setErrorMessage({ ...errorMessage, driverDobError: "" })
    }
    const handleDrivingLicense = (e) => {
        e.preventDefault();
        setLicense(e.target.value.slice(0, 50))
        if (e.target.value.length > 0) {
            setLicense(e.target.value.toUpperCase())
            setErrorMessage({ ...errorMessage, drivingLicenseError: '' })
        } else setErrorMessage({ ...errorMessage, drivingLicenseError: "Please enter valid Driver License ID" })
    }

    const handleAddressChange = (e) => {
        e.preventDefault();
        setAddress(VALIDATION.noSpecialCharacterValidation(e.target.value.slice(0, 200)))
        if (e.target.value.length > 0) {
            setAddress(VALIDATION.noSpecialCharacterValidation(e.target.value))
            setErrorMessage({ ...errorMessage, addressError: '' })
        } else setErrorMessage({ ...errorMessage, addressError: "Please enter Address" })
    }
    const onChangeDrivingExpInMonth = (e) => {
        e.preventDefault();
        setDrivingExpInMonths(e.target.value)
    }
    const onChangeDrivingExpInYrs = (e) => {
        e.preventDefault();
        setDrivingExpInYrs(e.target.value)

    }

    const onCheckValidation = (e) => {
        let regdrivercheck = props.driverDataReload ? props.driverDataReload : props?.regStakeholderMaster?.transporterDrivers;
        if (fullName.length == 0) {
            setErrorMessage({ ...errorMessage, fullNameError: "Please enter Driver Name" });
            return;
        }
        else if (!dob) {
            setErrorMessage({ ...errorMessage, driverDobError: "Please enter Date of birth" });
            return;
        }
        else if (!mobileNo || mobileNo.length == 0) {
            setErrorMessage({ ...errorMessage, mobileNoError: "Please enter Mobile No." });
            return;
        }
        else if (mobileNo.length != 10) {
            setErrorMessage({ ...errorMessage, mobileNoError: "Please enter valid Mobile No." });
            return;
        }
        else if (pincode.length !== 6) {
            setErrorMessage({ ...errorMessage, pincodeError: "Please enter valid Pincode" })
            return;
        }
        else if (address.length == 0) {
            setErrorMessage({ ...errorMessage, addressError: "Please enter Address" });
            return;
        }
        else if (licenseNo.length == 0) {
            setErrorMessage({ ...errorMessage, drivingLicenseError: "Please enter valid Driver License ID" })
            return;
        }

        else if (props.actionType === "edit" && errorMessage.mobileNoError && errorMessage.mobileNoError.length > 0) {
            setErrorMessage({ ...errorMessage, mobileNoError: "Contact No already exists." })
            return;
        }
        else if (props.actionType === "add" && regdrivercheck?.filter(item => (item.driverContactNo == mobileNo)).length > 0) {
            setErrorMessage({ ...errorMessage, mobileNoError: "Contact No already exists." })
            return;
        }
        var drivingLicenseDoc = documentArray && documentArray.filter((item) => item.documentType === DRIVING_LICENSE && (item.isActive == 1 || item.isActive == 3));
        if (!drivingLicenseDoc || drivingLicenseDoc.length == 0) {
            setErrorMessage({ drivingLicenseDocError: "Please upload driving license document" });
            return;
        }
        else {
            onSubmitClick(e)
        }
    }
    const onUploadCallBack = (docArray) => {
        setDocumentArray(docArray);
    }
    const onSubmitClick = (e) => {
        e.preventDefault();
        if (transporterDetails?.id === null || transporterDetails?.id === undefined) {
            delete transporterDetails?.id
        }
        if (props.actionType === 'edit') {
            let dataToBePassed = {
                "id": transporterDetails?.id,
                "regTransporterMasterId": props?.regStakeholderMaster?.id,
                "driverName": fullName,
                "driverDob": dob,
                "driverGender": gender,
                "driverContactNo": mobileNo,
                "driverAddress": address,
                "driverPincode": pincode,
                // "yearsOfExp": drivingExp,
                "agreementStartDate": agreementStartDate,
                "agreementEndDate": agreementEndDate,
                "driverType": "string",
                "driverLicenseId": licenseNo,
                "licenceIssueDate": licenceIssueDate,
                "licenceValidityEnddate": licenceValidityEnddate,
                "isActive": 1,
                "createdOn": "2022-09-30T11:51:23.894Z",
                "createdBy": "string",
                "updatedOn": "2022-09-30T11:51:23.894Z",
                "updatedBy": "string",
                "documents": documentArray ? documentArray : []
            }
            props.onSubmit(dataToBePassed);
            props.onClose();
        } else if (props.actionType === 'add') {
            let dataToBePassed = {
                "id": transporterDetails?.id ? transporterDetails?.id : uuidv4(),
                "regTransporterMasterId": props?.regStakeholderMaster?.id,
                "driverName": fullName,
                "driverDob": dob,
                "driverGender": gender,
                "driverContactNo": mobileNo,
                "driverAddress": address,
                "driverPincode": pincode,
                // "yearsOfExp": drivingExp,
                "agreementStartDate": agreementStartDate,
                "agreementEndDate": agreementEndDate,
                "driverType": "string",
                "driverLicenseId": licenseNo,
                "licenceIssueDate": licenceIssueDate,
                "licenceValidityEnddate": licenceValidityEnddate,
                "isActive": 1,
                "createdOn": "2022-09-30T11:51:23.894Z",
                "createdBy": "string",
                "updatedOn": "2022-09-30T11:51:23.894Z",
                "updatedBy": "string",
                "documents": documentArray ? documentArray : []
            }
            props.onSubmit(dataToBePassed);
            props.onClose();
        }
    }
    return (
        <>
            <Container maxWidth="xxl">
                {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>REG28</p>}
                <Typography variant="h5" gutterBottom>
                    {t('reg.driverDetails')}
                </Typography>
                <Grid container spacing={2} mt={2}>
                    <Grid item xs={12} lg={6}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <TextField fullWidth required
                                    error={errorMessage.fullNameError}
                                    helperText={errorMessage.fullNameError}
                                    type="text"
                                    value={fullName}
                                    disabled={((props.actionType === 'edit') && (ResourceUpdateMember.includes(checkUserDetails) && (checkUserDetails !== 'Reg-ITAdmin'))) ? true : false}
                                    label={t('reg.fullName')}
                                    onChange={(e) => handleFullNameChange(e)}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <FormControl fullWidth>
                                    <InputLabel>{t('preReg.gender')}</InputLabel>
                                    <Select label={t('preReg.gender')}
                                        value={gender}
                                        disabled={((props.actionType === 'edit') && (ResourceUpdateMember.includes(checkUserDetails) && (checkUserDetails !== 'Reg-ITAdmin'))) ? true : false}
                                        onChange={(e) => onDriverGenderChange(e)}>
                                        {GENDER.map((item) => <MenuItem value={item}>{item}</MenuItem>)}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={6}>
                                <FormControl fullWidth error={errorMessage.driverDobError}>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DesktopDatePicker
                                            inputFormat="DD/MM/YYYY"
                                            renderInput={(params) => <TextField {...params} />}
                                            sx={{ minWidth: 750 }}
                                            label="Date Of Birth"
                                            maxDate={subYears(new Date(), 18)}
                                            disabled={((props.actionType === 'edit') && (ResourceUpdateMember.includes(checkUserDetails) && (checkUserDetails !== 'Reg-ITAdmin'))) ? true : false}
                                            value={dob}
                                            onChange={(e) => handleDriverDobChange(e)}
                                        />
                                    </LocalizationProvider>
                                    <FormHelperText sx={{ color: 'red' }}>{errorMessage.driverDobError}</FormHelperText>
                                </FormControl>
                                {/* <TextField fullWidth
                            required
                            error={errorMessage.driverDobError}
                            helperText={errorMessage.driverDobError}
                            value={age}
                            type="number"
                            disabled={((props.actionType === 'edit') && (ResourceUpdateMember.includes(checkUserDetails) && (checkUserDetails !== 'Reg-ITAdmin'))) ? true : false}
                            label={t('reg.age')}
                            onChange={(e) => handleAgeChange(e)} inputProps={{
                                maxLength: 5
                            }} /> */}
                            </Grid>
                            <Grid item xs={12}>
                                <TextField fullWidth required
                                    error={errorMessage.mobileNoError}
                                    helperText={errorMessage.mobileNoError}
                                    type="number"
                                    onFocus={handleNumberFieldFocus}
                                    disabled={((props.actionType === 'edit') && (ResourceUpdateMember.includes(checkUserDetails) && (checkUserDetails !== 'Reg-ITAdmin'))) ? true : false}
                                    label={t('preReg.mobileNo')}
                                    value={mobileNo}
                                    onChange={(e) => handleMobileNo(e)}
                                    onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '.' || evt.key === '-' || evt.key === '+') && evt.preventDefault()} />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField fullWidth required
                                    error={errorMessage.pincodeError}
                                    helperText={errorMessage.pincodeError}
                                    type="number"
                                    onFocus={handleNumberFieldFocus}
                                    disabled={((props.actionType === 'edit') && (ResourceUpdateMember.includes(checkUserDetails) && (checkUserDetails !== 'Reg-ITAdmin'))) ? true : false}
                                    label={t('preReg.pincode')}
                                    value={pincode}
                                    onChange={(e) => handlePincodeChange(e)}
                                    onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '.' || evt.key === '-' || evt.key === '+') && evt.preventDefault()} />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField required
                                    error={errorMessage.addressError}
                                    helperText={errorMessage.addressError}
                                    fullWidth
                                    multiline
                                    label={t('main.address')}
                                    disabled={((props.actionType === 'edit') && (ResourceUpdateMember.includes(checkUserDetails) && (checkUserDetails !== 'Reg-ITAdmin'))) ? true : false}
                                    value={address}
                                    onChange={(e) => handleAddressChange(e)}
                                    inputProps={{
                                        maxLength: 500,

                                    }} />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} lg={6}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <TextField fullWidth required
                                    error={errorMessage.drivingLicenseError}
                                    helperText={errorMessage.drivingLicenseError}
                                    type="text"
                                    label={t('reg.drivingLicenseNo')}
                                    value={licenseNo}
                                    onChange={(e) => handleDrivingLicense(e)} inputProps={{
                                        maxLength: 20,
                                        style: { textTransform: "uppercase" }
                                    }}
                                />
                                <FileUploadMUI key={DRIVING_LICENSE}
                                    documentList={documentArray}
                                    documentType={DRIVING_LICENSE}
                                    callBackDocumentUpload={onUploadCallBack}
                                    stakeholderDetailId={props.regID}
                                    title={t('reg.uploadDrivingLicenseDoc')}
                                    stakeholderType="Transporter"
                                    errorMessage={errorMessage}
                                    setErrorMessage={setErrorMessage}
                                    documentError="drivingLicenseDocError"
                                //disabled={!ResourceUpdateMember.includes(checkUserDetails) ? true : false}
                                />
                                <div className='mandatory_field'>{errorMessage.drivingLicenseDocError}</div>
                            </Grid>
                            <Grid item xs={12} lg={6}>
                                <FormControl fullWidth>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DesktopDatePicker
                                            disableFuture
                                            inputFormat="DD/MM/YYYY"
                                            renderInput={(params) => <TextField {...params} />}
                                            sx={{ minWidth: 750 }}
                                            label="Licence Issued date"
                                            value={licenceIssueDate}
                                            onChange={(e) => handleDateChange(e, "licenceIssueDate")}
                                        />
                                    </LocalizationProvider>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} lg={6}>
                                <FormControl fullWidth>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DesktopDatePicker
                                            inputFormat="DD/MM/YYYY"
                                            renderInput={(params) => <TextField {...params} />}
                                            sx={{ minWidth: 750 }}
                                            label="Validity End date"
                                            value={licenceValidityEnddate}
                                            minDate={moment(new Date()).format(API_DATE_FORMAT)}
                                            onChange={(e) => handleDateChange(e, "licenceValidityEnddate")}
                                        />
                                    </LocalizationProvider>
                                </FormControl>
                            </Grid>
                            {/* <Grid item xs={12}>
                        <Typography>Driving Experience in</Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <FormControl fullWidth>
                            <InputLabel>{t('reg.years')}</InputLabel>
                            <Select label="Years" value={drivingExpInYrs} onChange={(e) => onChangeDrivingExpInYrs(e)}>
                                {Array.from(Array(50), (e, i) => {
                                    return <MenuItem key={i} value={i}>{i}</MenuItem>
                                })}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={6}>
                        <FormControl fullWidth>
                            <InputLabel>{t('reg.months')}</InputLabel>
                            <Select label="Months" value={drivingExpInMonths} onChange={(e) => onChangeDrivingExpInMonth(e)}>
                                {NUMBER_OF_MONTH.map((item) => <MenuItem value={item}>{item}</MenuItem>)}
                            </Select>
                            <FormHelperText sx={{ color: 'red' }}>{errorMessage.drivingExpError}</FormHelperText>
                        </FormControl>
                    </Grid> */}
                        </Grid>
                    </Grid>
                </Grid>
            </Container>
            <Box display='flex' alignItems="center" justifyContent="center" mt={3} mb={2} style={{ float: "right" }}>
                <Button sx={{ minWidth: 100 }}
                    variant="contained" onClick={props.onClose}>{t('reg.cancel')}</Button>
                <Button sx={{ minWidth: 100, ml: 1 }}
                    variant="contained" onClick={(e) => onCheckValidation(e)}>{props.actionType === "add" ? t('reg.add') : t('reg.update')}</Button>
            </Box>
        </>
    );
};
